import { Language } from '@shared/i18n';

export const getMapLocale = (lang?: Language) => {
	switch (lang) {
		case Language.TRADITIONAL_CHINESE:
			return 'zh-Hant';
		case Language.SIMPLIFIED_CHINESE:
			return 'zh-Hans';
		case Language.ENGLISH:
			return 'en-US';
		default:
			return 'en-US';
	}
};
